function TwilioService($q, $resource, $rootScope) {

    var twilioResource = $resource('/api/twilio', null, {
        purchase: {method: "POST", url: "/api/twilio/purchase"},
        search: {method: 'GET', url: '/api/twilio/availableNumbers/:areaCode', isArray: true},
        sendSms: {method: "POST", url: "/api/twilio/sendSms"},
        verifyNumber: {method: "POST", url: "/api/twilio/verifyNumber"}
    });

    this.getAreaCodes = function () {
        return twilioResource.areaCodes();
    };

    this.purchaseNumber = function (phoneNumber, logId) {
        return twilioResource.purchase({phoneNumber: phoneNumber, logId: logId});
    };

    this.sendSMSText = function (smsValues) {
        smsValues.senderId = $rootScope.user.id;
        return twilioResource.sendSms(smsValues).$promise;
    };

    this.searchByAreaCode = function (areaCode) {
        return twilioResource.search({areaCode: areaCode}).$promise;
    };

    this.verifyNumber = function (phoneNumber, logId) {
        var deferred = $q.defer();
        twilioResource.verifyNumber({phoneNumber: phoneNumber, logId: logId}).$promise.then(function (verified) {
            deferred.resolve(verified);
        });
        return deferred.promise;
    };
}

angular.module("onsite").service("twilioService", ["$q", "$resource", "$rootScope", TwilioService]);
